import React from "react";

const MyButton = (props) => {
  return (
    <div>
      <div href={props.link} className="btn my-btn btn-outline-light">
        {props.text}
      </div>
    </div>
  );
};

export default MyButton;
